import { render } from "./rolrAuthority.vue?vue&type=template&id=4262c648&scoped=true"
import script from "./rolrAuthority.vue?vue&type=script&lang=js"
export * from "./rolrAuthority.vue?vue&type=script&lang=js"

import "./rolrAuthority.vue?vue&type=style&index=0&id=4262c648&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4262c648"

export default script